<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/RMSzWZ/tc-custom/9781467463737.jpg?1718183001489" alt="This image is the cover for the book Sleep Like Me"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Sleep Like Me
      </h1>
      <p class="bookDescription body article font2">
        <p>A little boy can’t fall asleep, so he asks the animals how they do it. Will he doze off if he floats on his back like an otter? If he keeps one eye open like a duck? If he hangs upside down like a bat? Nothing seems to help, but all this trying is getting tiring…<br/><br/> This whimsically illustrated book features the real sleeping habits of ten different animals. Whether you snooze like a whale or nod off like a giraffe, <i>Sleep Like Me</i> is the perfect bedtime story for restless nights.<br/><br/><b>Alabama Department of Education</b> Alabama Children's Choice Camellia Award K-1 Nominee (2022-2023)</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Tatia Nadareishvili
      </h2>
      
      <p class="authorDescription body article"><B>Tatia Nadareishvili</B>&#160;studied illustration and graphic design at the Tbilisi State Academy of Arts. After working as an art therapist and teacher, she now works as an illustrator in her own studio. One day, while watching a random TV channel, Tatia came across a video of sperm whales sleeping upright in dark blue water. That inspired her to research the ways other animals sleep, which led to the creation of&#160;<I>Sleep Like Me.</I><BR /> &#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Wm. B. Eerdmans Publishing Co.
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?538546d1